import { render, staticRenderFns } from "./UnderDepartment.vue?vue&type=template&id=130ed9e3&scoped=true"
import script from "./UnderDepartment.vue?vue&type=script&lang=js"
export * from "./UnderDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ed9e3",
  null
  
)

export default component.exports